import type { FieldValues } from "react-hook-form";
import { type SurveyBodyProps } from "../components/survey-body";
import { type SurveyFooterProps } from "../components/survey-footer";
import { type SurveyHeaderProps } from "../components/survey-header";
import { ScreenTypeEnum } from "./survey-step";

export type NextAction = (formData: FieldValues, preNavigationAction?: () => Promise<void>) => void;
export type BackAction = (event: React.MouseEvent<HTMLButtonElement>) => void;
export type SkipAction = (event: React.MouseEvent<HTMLButtonElement>) => void;

export class SurveyStepAction<T extends NextAction | BackAction | SkipAction = NextAction> {
  constructor(
    label: string,
    onClick: T | undefined = undefined,
    disabled: boolean = false,
    isLoading: boolean = false
  ) {
    this.label = label;
    this.onClick = onClick;
    this.disabled = disabled;
    this.isLoading = isLoading;
  }

  static create<T extends NextAction | BackAction | SkipAction = NextAction>(
    label: string,
    onClick: T | undefined = undefined,
    disabled: boolean = false,
    isLoading: boolean = false
  ): SurveyStepAction<T> {
    return new SurveyStepAction(label, onClick, disabled, isLoading);
  }

  public label: string;
  public onClick: T | undefined;
  public disabled: boolean;
  public isLoading: boolean;
}

export class SurveyCurrentStep {
  public stepName: string = "";
  public header: SurveyHeaderProps = {
    title: "Su di te",
    onClose: () => {},
  };
  public body: SurveyBodyProps = {
    title: "",
    guidedMode: undefined,
    screenType: ScreenTypeEnum.QUESTION,
    screenRef: undefined,
    description: "",
    inputs: [],
    advice: <></>,
    skip: undefined,
    ctas: undefined,
    extra: undefined,
    submit: undefined,
    excludedFields: [],
    progressPercentage: 0,
  };
  public footer: SurveyFooterProps = {
    nextCanSkip: false,
    back: undefined,
    next: undefined,
  };
  public resolvedContextId?: string;
  public onError: (error: Error) => void = function defaultOnError(error: Error) {
    console.error(error);
  };
}
